import { useFeatureFlagEnabled } from '@posthog/react';

/** PostHog flag key gating the ConnectBase retrying and failed messages in a project. */
export const CONNECTBASE_STATUS_MESSAGES_FLAG = 'connectbase-show-status-messages';

/** Fail-closed: `undefined`/`false` from PostHog (including while flags are still loading) hides the messages. */
export function useConnectbaseStatusMessagesEnabled(): boolean {
  return useFeatureFlagEnabled(CONNECTBASE_STATUS_MESSAGES_FLAG) === true;
}
